import { provide, inject, type InjectionKey } from 'vue'

export interface ComponentScopedVariablesContext {
  // The componentType key in ComponentRegistry — the interpolation modal uses
  // it to look up the matching `scopedVariables` metadata block.
  componentType: string
  // Called on every interpolation read so Vue tracks the refs the getter
  // touches and NodeView re-renders as they change.
  getValues: () => Record<string, unknown>
}

export const ComponentScopedVariablesSymbol: InjectionKey<ComponentScopedVariablesContext> = Symbol(
  'ComponentScopedVariables',
)

// Call once from a render component's setup() to expose values that TipTap
// descendants can reference as `comp.<name>` in interpolation. Nested
// components override (Vue's nearest-provider semantics), so TipTaps inside
// the deepest scoped-variables component see that component's scope.
export function useComponentScopedVariables(
  componentType: string,
  getValues: () => Record<string, unknown>,
): void {
  provide(ComponentScopedVariablesSymbol, { componentType, getValues })
}

export function useComponentScopedVariablesIfAvailable(): ComponentScopedVariablesContext | null {
  return inject(ComponentScopedVariablesSymbol, null)
}
